// The 3D room needs WebGL. Browsers can switch it off (hardware acceleration disabled, a blocklisted
// GPU driver, Lockdown Mode), so check before downloading the scene.
export function hasWebGL(): boolean {
  try {
    const c = document.createElement('canvas');
    const gl = c.getContext('webgl2') || c.getContext('webgl');
    return !!gl;
  } catch {
    return false;
  }
}

export type GLHelp = { browser: string; steps: string[] };

/** How to turn WebGL back on in the visitor's browser, best guess from the user agent. */
export function webGLHelp(ua = navigator.userAgent): GLHelp {
  // Every browser on iPhone and iPad runs on WebKit, where Lockdown Mode is what turns WebGL off.
  if (/iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) {
    return { browser: 'Safari on iPhone/iPad', steps: [
      'Tap the aA (or page menu) button in the address bar → Website Settings, and turn off Lockdown Mode for this site.',
      'Reload the page.',
    ] };
  }
  if (/Firefox\//.test(ua)) {
    return { browser: 'Firefox', steps: [
      'Settings → General → Performance: untick “Use recommended performance settings”, then tick “Use hardware acceleration when available”.',
      'Restart Firefox. Still off? Open about:config and set webgl.disabled to false.',
    ] };
  }
  if (/Chrome|Chromium|Edg\//.test(ua)) {
    const browser = /Edg\//.test(ua) ? 'Edge' : /OPR\//.test(ua) ? 'Opera' : 'Chrome';
    return { browser, steps: [
      'Settings → System → turn on “Use graphics acceleration when available”, then relaunch.',
      'Still off? Your graphics driver may be blocked; updating it usually helps. chrome://gpu shows the details.',
    ] };
  }
  if (/Safari\//.test(ua)) {
    return { browser: 'Safari', steps: [
      'Safari → Settings for This Website: untick “Enable Lockdown Mode”, then reload.',
    ] };
  }
  return { browser: 'your browser', steps: [
    'Turn on hardware (graphics) acceleration in your browser settings, then restart it.',
  ] };
}
